"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const chakras = [{
  id: "root",
  name: "Wurzelchakra ",
  description: "Verankert uns in der physischen Welt. Steht für Urvertrauen, Stabilität, Erdung und unsere grundlegenden Überlebensinstinkte.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_root.png"
}, {
  id: "sacral",
  name: "Sakralchakra ",
  description: "Das Zentrum unserer Emotionen, Kreativität und Sinnlichkeit. Es lehrt uns, mit dem Fluss des Lebens zu gehen.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_sacral.png"
}, {
  id: "solar",
  name: "Solarplexuschakra ",
  description: "Der Sitz unserer Persönlichkeit und inneren Kraft. Hier finden wir Selbstvertrauen, Willensstärke und unsere Identität.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_solarplexus.png"
}, {
  id: "heart",
  name: "Herzchakra ",
  description: "Die Brücke zwischen Körper und Geist. Es ist das Zentrum für bedingungslose Liebe, Mitgefühl, Vergebung und Heilung.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_heart.png"
}, {
  id: "throat",
  name: "Halschakra ",
  description: "Unser Ausdruckszentrum. Es ermöglicht uns, unsere inneren Wahrheit klar, authentisch und liebevoll zu kommunizieren.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_throat.png"
}, {
  id: "third-eye",
  name: "Stirnchakra ",
  description: "Das Auge der Intuition. Es öffnet den Geist für tiefere Einsichten, innere Weisheit und klare Visionen jenseits des Sichtbaren.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_thirdeye.png"
}, {
  id: "crown",
  name: "Kronenchakra ",
  description: "Unsere Verbindung zum Universellen. Es steht für spirituelles Erwachen, reines Bewusstsein und tiefe innere Stille.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_stone_crown.png"
}];
export default function HolisticResonance() {
  return <section id="holisticresonance" className="bg-background relative overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className="bg-primary/5 absolute inset-0 pointer-events-none" />
      
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center mb-12 md:mb-20">
          <h1 className="font-serif text-foreground mb-6 text-4xl font-medium tracking-tight sm:text-5xl md:text-6xl">
            Ganzheitliche Resonanz
          </h1>
          <Link className="text-muted-foreground text-lg leading-relaxed md:text-xl underline cursor-pointer"><p className="text-muted-foreground text-lg leading-relaxed md:text-xl" className="text-muted-foreground text-lg leading-relaxed md:text-xl">Entdecke bei Wandelherz die transformative Kraft der Energiearbeit. Meine Praktiken zielen darauf ab, emotionale Blockaden zu lösen und Körper, Geist und Seele in einen harmonischen, geerdeten Einklang zu bringen.</p></Link>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:gap-12 items-start">
          {}
          <Card className="border-primary/20 bg-card/80 backdrop-blur-sm shadow-sm h-full flex flex-col">
            <CardHeader className="pb-4">
              <h2 className="leading-none font-semibold font-serif text-2xl md:text-3xl text-primary">
                Reiki-Energieheilung
              </h2>
              <CardDescription className="text-base mt-2">Eine sanfte, aber tiefgreifende Methode zur Stressreduktion und Aktivierung der natürlichen Selbstheilungskräfte.<br /><br />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex flex-col justify-between gap-6">
              <Link className="text-muted-foreground leading-relaxed underline cursor-pointer"><p className="text-muted-foreground leading-relaxed" className="text-muted-foreground leading-relaxed">
                Durch das sanfte Auflegen der Hände wird universelle Lebensenergie 
                kanalisiert. Diese Praxis hilft dabei, das Nervensystem zu beruhigen, 
                emotionale Altlasten sanft zu lösen und einen Raum tiefer, 
                vertrauensvoller Entspannung zu schaffen. Ideal für alle, die 
                Abstand vom Alltag suchen und neue Kraft schöpfen möchten.
              </p></Link>

              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/glowing_hands.png" alt="Heilende Hände während einer Reiki-Sitzung" className="w-full h-64 object-cover rounded-lg shadow-sm" />
              
              <Button asChild variant="outline" className="w-fit border-primary/30 hover:bg-primary/10 text-primary">
                <Link to="/ReikiTherapyPage">
                  Mehr erfahren
                </Link>
              </Button>
            </CardContent>
          </Card>

          <Card className="border-primary/20 bg-card/80 backdrop-blur-sm shadow-sm h-full flex flex-col">
            <CardHeader className="pb-4">
              <h2 className="leading-none font-semibold font-serif text-2xl md:text-3xl text-primary">
                Trauma‑Heilung
              </h2>
              <CardDescription className="text-base mt-2">Ein sicherer Raum für die behutsame Integration emotionaler Erfahrungen und die Stärkung der inneren Belastbarkeit.<br /><div data-ast-id="f:/src/pages/Angebote/sections/HolisticResonance.tsx|sig:wgkvc5" data-ast-start="7060" data-ast-end="7077" contenteditable="false" style={{}}><br /></div><div data-ast-id="f:/src/pages/Angebote/sections/HolisticResonance.tsx|sig:wgkvba" data-ast-start="7077" data-ast-end="7094" contenteditable="false" style={{}}><br /></div><div data-ast-id="f:/src/pages/Angebote/sections/HolisticResonance.tsx|sig:wgkvaf" data-ast-start="7094" data-ast-end="7146" contenteditable="false" style={{}}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</div></CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex flex-col justify-between gap-6">
              <p className="text-muted-foreground leading-relaxed">
                Traumaarbeit bei Wandelherz basiert auf einem sanften, körperorientierten Ansatz. 
                Wir arbeiten daran, das Nervensystem zu regulieren und blockierte Energien 
                wieder in Fluss zu bringen. Ziel ist es, ein tiefes Gefühl von Sicherheit 
                und Selbstbestimmung im eigenen Leben zurückzugewinnen.
              </p>

              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/trauma_healing_support.png" alt="Unterstützende Hände symbolisieren den Prozess der Trauma-Heilung" className="w-full h-64 object-cover rounded-lg shadow-sm" />
              
              <Dialog>
                <DialogTrigger asChild>
                  <Button variant="outline" className="w-fit border-primary/30 hover:bg-primary/10 text-primary">
                    Mehr erfahren
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[600px]">
                  <DialogHeader>
                    <DialogTitle className="font-serif text-2xl text-primary mb-2">
                      Heilung durch Präsenz & Mitgefühl
                    </DialogTitle>
                    <DialogDescription className="text-base leading-relaxed">Ein Trauma ist ein schwerwiegendes, lebensbedrohliches, ängstigendes, erschütterndes Erlebnis, welches sich in psychischen und körperlichen Beschwerden äussert.<br /><br />Ein Trauma kann entstehen durch:<br />- Tod eines nahestehenden Menschen&nbsp;<br />- Körperliche Gewalt, psychische Gewalt<br />- Unfälle<br />- Krankheiten, Verletzungen körperlich oder psychisch<br />- Zeuge von Gewalttaten, Überfällen, Katastrophen<br />- Verlust von Arbeitsstelle, Partnerschaft, Eigentum<br /><br />Wir schaffen gemeinsam einen Raum, in dem alles sein darf. Es geht nicht darum, das Geschehene ungeschehen zu machen, sondern die eigene Kraft im Hier und Jetzt wiederzufinden und die innere Resilienz nachhaltig zu stärken.</DialogDescription>
                  </DialogHeader>
                </DialogContent>
              </Dialog>
            </CardContent>
          </Card>

          <Card className="border-primary/20 bg-card/80 backdrop-blur-sm shadow-sm h-full flex flex-col">
            <CardHeader className="pb-4">
              <h2 className="leading-none font-semibold font-serif text-2xl md:text-3xl text-primary">
                Meditation und Achtsamkeit
              </h2>
              <CardDescription className="text-base mt-2">Geführte Praktiken zur Beruhigung des Geistes und zur Entstehung &nbsp;einer tieferen inneren Präsenz.</CardDescription>
            </CardHeader>
            <CardContent className="flex-1 flex flex-col justify-between gap-6">
              <p className="text-muted-foreground leading-relaxed">
                Lerne, den Lärm der Welt für einen Moment auszublenden und die Stille 
                in dir selbst zu entdecken. Meine Achtsamkeitstrainings bieten dir 
                praktische Werkzeuge, um gelassener mit Stress umzugehen und bewusster 
                durch das Leben zu gehen.
              </p>

              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/meditation_serenity_nature.png" alt="Eine Person meditiert in einer ruhigen Naturlandschaft" className="w-full h-64 object-cover rounded-lg shadow-sm" />
              
              <Dialog>
                <DialogTrigger asChild>
                  <Link className="w-fit border-primary/30 hover:bg-primary/10 text-primary underline cursor-pointer" to="/RetreatsPage"><Button variant="outline" className="w-fit border-primary/30 hover:bg-primary/10 text-primary">
                    Mehr erfahren
                  </Button></Link>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[600px]">
                  <DialogHeader>
                    <DialogTitle className="font-serif text-2xl text-primary mb-2">
                      Den Geist klären, das Herz öffnen
                    </DialogTitle>
                    <DialogDescription className="text-base leading-relaxed">
                      Meditation ist die Kunst des einfachen Seins. In meinen Sitzungen 
                      führe ich dich sanft in verschiedene Techniken ein – von der 
                      Atembeobachtung bis hin zu Visualisierungen.
                      <br /><br />
                      Achtsamkeit hilft uns, die Verbindung zu unseren Bedürfnissen 
                      wiederherzustellen und Reaktionen durch bewusste Antworten zu 
                      ersetzen. Es ist ein Weg zu mehr innerer Freiheit und Lebensqualität, 
                      der jederzeit und überall praktiziert werden kann.
                    </DialogDescription>
                  </DialogHeader>
                </DialogContent>
              </Dialog>
            </CardContent>
          </Card>

          {}
          <Card className="border-primary/20 bg-card/80 backdrop-blur-sm shadow-sm h-full flex flex-col">
            <CardHeader className="pb-4">
              <h2 className="leading-none font-semibold font-serif text-2xl md:text-3xl text-primary">
                Chakra-Ausgleich
              </h2>
              <CardDescription className="text-base mt-2">Harmonisierung der sieben Hauptenergiezentren für emotionale Klarheit und innere Balance.<br /><br /><div data-ast-id="f:/src/pages/Angebote/sections/HolisticResonance.tsx|sig:qaywq1" data-ast-start="12628" data-ast-end="12645" contenteditable="false" style={{}}><br /></div><div data-ast-id="f:/src/pages/Angebote/sections/HolisticResonance.tsx|sig:qaywp6" data-ast-start="12645" data-ast-end="12703" contenteditable="false" style={{}}>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</div></CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground leading-relaxed mb-6">
                Unsere Chakren sind feinstoffliche Energiezentren, die unsere 
                physische, emotionale und spirituelle Gesundheit beeinflussen. 
                Erfahre mehr über die einzelnen Zentren und ihre Bedeutung 
                für dein Wohlbefinden.
              </p>
              
              <Accordion type="single" collapsible className="w-full">
                {chakras.map((chakra, i) => {
                const chakraColors: Record<string, string> = {
                  root: "bg-red-500/10",
                  sacral: "bg-orange-500/10",
                  solar: "bg-yellow-500/10",
                  heart: "bg-green-500/10",
                  throat: "bg-blue-500/10",
                  "third-eye": "bg-indigo-500/10",
                  crown: "bg-purple-500/10"
                };
                const chakraIcons: Record<string, string> = {
                  sacral: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_sacral.png",
                  solar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_solarplexus.png",
                  heart: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_heart.png",
                  throat: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_throat.png",
                  "third-eye": "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_thirdeye.png",
                  crown: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_crown.png"
                };
                return <AccordionItem key={chakra.id} value={chakra.id} data-index={i} className="border-primary/10">
                      <AccordionTrigger className="hover:no-underline hover:text-primary transition-colors py-3">
                        <div className="flex items-center gap-3 text-left">
                          <div className={`${chakraColors[chakra.id] || "bg-primary/10"} p-2 rounded-full text-primary`}>
                            <img src={i === 0 ? "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/chakra_icon_root.png" : chakraIcons[chakra.id] || chakra.icon} alt={chakra.name} className="size-4" />
                          </div>
                          <span className="font-medium">{chakra.name}</span>
                        </div>
                      </AccordionTrigger>
                      <AccordionContent className="text-muted-foreground leading-relaxed pl-11 pr-4 pb-4">
                        {chakra.description}
                      </AccordionContent>
                    </AccordionItem>;
              })}
              </Accordion>

              <Button asChild variant="outline" className="w-fit border-primary/30 hover:bg-primary/10 text-primary mt-6">
                <Link to="/ChakraHealingPage">
                  Mehr erfahren
                </Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}